export default {
    mobileConversionConfig: {
        category: 'graphic',
        isSuitableForProportionGrouping: true
    },
    rotatable: true
}
